import * as React from "react";
import Grid from "@mui/material/Grid";
import { CmpStatusIcon, CmpTypographyField } from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import { Typography } from "@mui/material";
export const CyclecountDetailTblCard = ({ data = [], onClick = () => { } }) => {
  return (

    <Grid container spacing={1} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid item xs={12} key={index} onClick={() => {
          let items = { row: item };
          onClick(items);
        }}>
          <div className="easy-putaway-card">
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>

              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Sheet No
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.B_SheetId}
                </Typography>
              </Grid>


              <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                  Unit
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.UnitName}
                </Typography>
              </Grid>
              {/* <Grid item xs={6} md={3}>
                <Typography variant="subtitle1" className="label">
                RefNo
                </Typography>
              </Grid>
              <Grid item xs={6} md={3}>
                <Typography variant="body1" className="value">
                  {item.RefNo}
                </Typography>
              </Grid> */}

              <Grid item xs={12} md={12}>
                <Typography variant="body1" className="value">
                  {item.ItmName}
                </Typography>
              </Grid>

            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
